import { stringifyUrl } from '@/utils/url';
import Konva from 'konva'
import { fontNameEn } from './utils'
import { judgeDeviceType } from '@/utils/device';
const isIOS = judgeDeviceType.isIOS;

export class SegmentPlayer {
  // segment
  segments: any[] = [];
  activeSegmentIndex = 0; // 前播放的segment坐标
  currentTime = 0; // 当前播放时间
  _on: any; // 绑定事件
  paused: boolean = true;
  initMap: any = {}; // 初始化标记
  loadingCallback: () => void;

  // 画布
  stage: Konva.Stage;
  stageText: Konva.Stage;
  stageWidth = 0;
  stageHeight = 0;
  layerVideo: Konva.Layer;  // 背景层-图片
  layerImage: Konva.Layer;  // 背景层-视频
  textLayer: SubtitlesLayer; // 装饰层-字幕
  // 视频
  videoImages: (Konva.Image | null)[] = [];
  videos: (videoPlayer | null)[] = [];
  video: (videoPlayer | null);
  anim: Konva.Animation;
  // 图片
  cacheImagesMap = {};
  images: (Konva.Image | null)[] = [];
  image: Konva.Image | null = null;
  imgEndTime = 0; // 结束图片播放的时间毫秒值，用于判断是否播放下一段
  imgTimer = null; // 图片播放计时器

  // 音频-配音
  audios: (AudioPlayer | null)[] = [];
  audio: AudioPlayer | null; // 当前播放音频

  playCallback = null; // 播放党回调

  constructor({ segments, canvasRef, on = {} }) {
    // 设置数据
    this.segments = segments || [];
    this.stageWidth = canvasRef.clientWidth;
    this.stageHeight = canvasRef.clientHeight;
    this._on = on;
    // 判断是否初始化完成
    this.initMap = {
      image: false,
      video: false,
    };
    // 初始化画布
    this.initStage();
    // 背景层
    this.initImages();
    this.initVideos();
    // 装饰层-字幕
    this.textLayer = new SubtitlesLayer({
      segments: this.segments,
      stage: this.stageText,
      scaleRatio: this.scaleRatio,
      on: {
        // init: () => this.initMap.text = true,
        edit: this._on.subtitlesEdit,
        change: this._on.subtitlesChange
      }
    });

    // 音频
    this.initAudios();
    this.audio = this.audios[0];
  }
  get activeSegment() {
    return this.segments[this.activeSegmentIndex];
  }
  get scaleRatio() { // 画布与segment比例，主要是字幕使用
    let ratio = 1;
    if (this.segments.length) {
      ratio = this.stageHeight / this.segments[0].height;
    }
    return ratio;
  }
  // 播放，从time(s)时间播放
  play(time = 0, callback?: any) {
    try {
      if (callback) this.playCallback = callback
      this.doPlay(time)
    } catch (err) {
      this.errorCallback(err)
    }
  }
  doPlay(t = 0, i = -1) {
    const time = i > -1 && this.segments[i].startTime || t; // 传入具体播放段，使用该播放段的开始时间
    const index = this.getSegmentIndexByTime(time);
    if (index === -1) return;
    // 停止当前播放
    this.pause();
    // 设置当前segment和时间
    this.currentTime = time;
    this.activeSegmentIndex = index;
    const segment = this.activeSegment;
    // console.log(index, 'play', segment, time)
    // 重设当前数据，并进行播放或绘制
    this.paused = false;
    const playTime = time - segment.startTime;
    this.audio = this.audios[index];
    if (this.audio) this.playAudio(playTime);
    this.video = this.videos[index];
    if (this.video) {
      this.playVideo(playTime);
      this.layerImage.hide();
      this.layerVideo.show();
    }
    this.image = this.images[index];
    if (this.image) {
      this.layerVideo.hide();
      this.layerImage.show();
      this.imgEndTime = new Date().getTime() + (segment.endTime - time) * 1000;
      this.playImage();
    }
    this.textLayer.show(time);
  }
  // 尝试播放第一个视频，并马上暂停，以解决iOS首次播放视频错误的问题
  tryPlayFirstVideo() {
    const firstVideo = this.videos.find(video => video);
    if (!firstVideo) return;
    firstVideo.play(0).then(res => {
      if (res) firstVideo.pause();
    })
  }
  // 检查播放问题
  checkPlay() {
    return new Promise((resolve) => {
      let count = 0;
      const sum = this.videos.length + this.audios.length;
      function checkCount() {
        count++;
        if (count === sum) {
          // console.log('checkPlay done')
          resolve(true);
        }
      }
      for (let index = 0; index < this.audios.length; index++) {
        const audio = this.audios[index];
        if (audio) {
          audio.checkPlay().then(() => {
            checkCount();
          });
        } else {
          checkCount();
        }

      }
      for (let index = 0; index < this.videos.length; index++) {
        const video = this.videos[index];
        if (video) {
          video.checkPlay().then(() => {
            checkCount();
          });
        }
        checkCount();
      }
    });
  }
  pause() {
    this.paused = true;
    this.pauseAudio();
    this.pauseVideo();
    this.pauseImage();
  }
  // 对某个时间进行显示
  show(time = 0) {
    const index = this.getSegmentIndexByTime(time);
    if (index === -1) return;
    // 设置当前segment和时间
    this.currentTime = time;
    this.activeSegmentIndex = index;

    this.video = this.videos[index];
    if (this.video) {
      this.layerImage.hide();
      this.layerVideo.show();
      const playTime = time - this.activeSegment.startTime;
      this.showVideo(playTime);
    }

    this.image = this.images[index];
    if (this.image) {
      this.layerVideo.hide();
      this.layerImage.show();
      this.showImage();
    }

    // 字幕显示
    this.textLayer?.show(time);
  }
  // 重新设置画布宽高
  resize(canvasRef) {
    const { clientWidth: w, clientHeight: h } = canvasRef
    this.stageWidth = w;
    this.stageHeight = h;
    this.stage.width(w);
    this.stage.height(h);
    this.stageText.width(w);
    this.stageText.height(h);
    this.video.setSize(this.stageWidth, this.stageHeight);

    this.videoImages.map((videoImage) => {
      if (videoImage) {
        videoImage.width(w);
        videoImage.height(h);
      }
    })

    this.images.map((image) => {
      if (image) {
        image.width(w);
        image.height(h);
      }
    })
    this.textLayer.resize(this.scaleRatio);

  }
  // 更新字幕
  updateSubtitle(segments) {
    this.textLayer.updateSubtitle(segments);
  }
  initCallback(loadingCallback) {
    this.loadingCallback = loadingCallback;
  }
  checkInit() {
    // 判断initMap是否所有值都为true
    if (Object.values(this.initMap).every(item => item)) {
      if (this.paused) this.show(this.currentTime);
      // console.log('showVideo----------------', this.videoImages[this.activeSegmentIndex], this.video)
      this.loadingCallback();
    }
  }
  destroy() {
    this.pause();
    this.stage.destroy();
  }
  // timeupdate时间更新回调
  timeupdateCallback() {
    if (this._on.timeupdate) {
      this._on.timeupdate(this.currentTime, this.activeSegment);
    }
  }
  errorCallback(err) {
    if (this._on.error) {
      this._on.error(err);
    }
  }
  // 一段segment播放结束回调，继续播放下一段
  playerEndCallback() {
    if (this.activeSegmentIndex < this.segments.length - 1) {
      // 播放结束进行设置时间后播放下一个段，用第二个参数明确播放段避免播放出错
      this.doPlay(this.activeSegment.endTime, this.activeSegmentIndex + 1);
      if (this._on.changeSegment) {
        this._on.changeSegment();
      }
    } else {
      // 全部播放结束
      this.pause();
      if (this._on.ended) {
        this._on.ended();
      }
    }
  }
  changeLoading(bol) {
    if (this._on.changeLoading) {
      this._on.changeLoading(bol);
    }
  }

  // 根据时间获取要渲染的segment
  getSegmentIndexByTime(time) {
    return this.segments.findIndex(item => item.startTime <= time && item.endTime > time)
  }

  /****************************** 音频 ******************************/
  initAudios() {
    for (let index = 0; index < this.segments.length; index++) {
      const segment = this.segments[index];
      this.audios.push(this.getAudios(segment.audioUrl))
    }
  }
  getAudios(audioUrl) {
    if (!audioUrl) return null;
    // return new backgroundAudioPlayer({ audioUrl });
    return new AudioPlayer({
      audioUrl: audioUrl,
      on: {
        'error': (err) => {
          console.log('error', audioUrl)
          this.errorCallback(err);
        },
        'ended': () => {
          if (!this.audio) return;
          // this.playerEndCallback() // 以视频结束为准，存在audio时长小于video时长/speed
        },
        // 'timeupdate': () => {
        //   if (!this.audio) return;
        //   if (this.audio.paused) return; // 音频暂停中，不继续推动
        //   this.currentTime = this.audio.currentTime + this.activeSegment.startTime;
        //   this.timeupdateCallback();
        // },
      }
    });
  }
  playAudio(time) {
    this.audio?.play(time);
  }
  pauseAudio() {
    this.audio?.pause();
  }
  /****************************** 音频 ******************************/

  // 画布
  initStage() {
    this.stage = new Konva.Stage({
      container: 'short_video_image',
      width: this.stageWidth,
      height: this.stageHeight,
    })

    this.stageText = new Konva.Stage({
      container: 'short_text',
      width: this.stageWidth,
      height: this.stageHeight,
    })
  }
  async toImageBlob() {
    return this.stage.toBlob({
      x: 0,
      y: 0,
      width: this.stageWidth,
      height: this.stageHeight,
      pixelRatio: 1 / this.scaleRatio,
    }).then(blob => {
      return blob;
    }).catch(err => {
      console.log('toImageBlob err', err)
    })
  }

  /****************************** 视频 ******************************/
  initVideos() {
    const stage = this.stage;
    const layer = new Konva.Layer();
    stage.add(layer);
    this.layerVideo = layer;
    this.anim = new Konva.Animation(function () {
      // do nothing, animation just need to update the layer
    }, layer);

    for (let index = 0; index < this.segments.length; index++) {
      const segment = this.segments[index];
      const muted = segment.type === 'explanation'; // 静音
      // 第一屏为video时需要等这个video的loadedmetadata
      const loadedmetadataCallback = index === 0 ? () => {
        this.initMap.video = true;
        this.checkInit();
      } : () => { };
      const video = this.getVideo({
        videoUrl: segment.videoUrl,
        muted,
        loadedmetadataCallback,
        speed: segment.speed,
      });
      this.videos.push(video);

      if (!video) {
        this.videoImages.push(null);
        continue;
      }
      const image = new Konva.Image({
        image: video.video,
        x: 0,
        y: 0,
        width: stage.width(),
        height: stage.height()
      })
      layer.add(image);
      this.videoImages.push(image);
      // console.log(`第${index + 1}个视频节点开始预加载`, segment.videoUrl);
    }

  }

  getVideo({ videoUrl, muted, speed = 1, loadedmetadataCallback = () => { } }) {
    if (!videoUrl) {
      loadedmetadataCallback();
      return null;
    }
    // 改为直接调用,因为iOS有的机型无法触发loadedmetadata
    setTimeout(() => {
      loadedmetadataCallback();
    }, 1500);
    return new videoPlayer({
      videoUrl,
      muted,
      speed,
      on: {
        'error': (err) => {
          this.errorCallback(err);
          console.log('videoPlayer error', err)
        },
        'pause': () => {
          // console.log('videoPlayer pause')
        },
        "loadedmetadata": loadedmetadataCallback,
        'timeupdate': () => {
          if (!this.video) return;
          if (this.paused) {
            // console.log('videoPlayer timeupdate paused', this.paused)
            return; // 视频暂停中，不继续推动
          }
          this.currentTime = this.video.currentTime / this.video.speed + this.activeSegment.startTime;
          if(this.audio) {
            const diff = (this.audio.currentTime + this.activeSegment.startTime - this.currentTime)
            if(diff < -0.5) {
              setTimeout(() => {
                this.doPlay(this.currentTime); // iOS音频播放停止，暂停重播
              }, 200);
            }
          }
          this.timeupdateCallback();
          this.textLayer?.show(this.currentTime); //字幕显示
        },
        'ended': () => {
          // console.log('videoPlayer ended')
          if (!this.video) return;
          this.playerEndCallback()
        },
      }
    })
  }

  showVideo(time) {
    this.removeVideos();
    this.videoImages[this.activeSegmentIndex]?.moveToTop(); // 置顶显示
    this.video?.setCurrentTime(time);
    this.video?.pause();
    this.anim?.start();
  }
  playVideo(time) {
    this.removeVideos();
    this.videoImages[this.activeSegmentIndex]?.moveToTop(); // 置顶显示
    if (!this.video.oncePlay) this.changeLoading(true);
    this.video?.play(time).then(() => {
      this.changeLoading(false);
      this.playCallback();
    });
    this.anim?.start();
  }
  // 清除一些视频，防止iOS上播放时，视频过多导致显示异常（画布变小）
  removeVideos() {
    const indexArr = [];
    this.videoImages.map((item, index) => {
      if (item) indexArr.push(index);
    })
    const count = 2; // 前后各留n个,即画布上始终保留2n+1个视频节点
    if (indexArr.length < count * 2 + 1) return; // 低于2n+1个视频，不进行清除
    let closest = 0;
    let closestDiff = Math.abs(indexArr[0] - this.activeSegmentIndex);
    for (let i = 1; i < indexArr.length; i++) {
      const currentDiff = Math.abs(indexArr[i] - this.activeSegmentIndex);
      if (currentDiff < closestDiff) {
        closest = i;
        closestDiff = currentDiff;
      }
    }
    let pos = closest - count;
    if (pos < 0) pos = indexArr.length + pos;
    const needIndexArr = [];
    while (needIndexArr.length < count * 2 + 1) {
      needIndexArr.push(indexArr[pos]);
      pos++;
      if (pos > indexArr.length - 1) pos = 0;
    }
    for (let i = 0; i < this.videoImages.length; i++) {
      const item = this.videoImages[i];
      if (item && !needIndexArr.includes(i)) {
        item.setAttrs({ isRemove: true })
        item.remove();
      } else if (item && needIndexArr.includes(i) && item.getAttr('isRemove')) {
        item.setAttrs({ isRemove: false })
        this.layerVideo.add(item);
      }
    }
  }

  pauseVideo() {
    this.video?.pause();
    // this.anim?.stop(); // 先不stop，偶现有问题
  }

  /****************************** 视频 ******************************/

  /****************************** 图片 ******************************/
  initImages() {
    const stage = this.stage;
    const layer = new Konva.Layer()
    stage.add(layer)
    this.layerImage = layer;
    for (let index = 0; index < this.segments.length; index++) {
      const segment = this.segments[index];
      const { video: videoObj, type } = segment;
      const imageUrl = videoObj.image_url; // 图片地址
      // 第一屏为image时需要等这个image加载完毕
      const loadedImageCallback = index === 0 ? () => {
        this.initMap.image = true;
        this.checkInit();
      } : () => { };
      if (imageUrl || type === 'image_video') {
        this.loadImage(imageUrl).then(imageObj => {
          const node = new Konva.Image({
            image: imageObj,
            x: 0,
            y: 0,
            width: stage.width(),
            height: stage.height(),
          });
          layer.add(node);
          node.hide(); // 默认隐藏
          this.images[index] = node;
          loadedImageCallback();
        });
      } else {
        loadedImageCallback();
        this.images[index] = null;
      }
    }
  }
  loadImage(url): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      if (this.cacheImagesMap[url]) {
        resolve(this.cacheImagesMap[url]);
        return;
      }
      const img = new Image();
      img.src = url;
      img.onload = () => {
        this.cacheImagesMap[url] = img;
        resolve(img);
      }
      img.onerror = (err) => {
        reject(err);
        console.log(err);
      };
      // img.crossOrigin = 'anonymous';
    });
  }
  // 播放图片，目前每段只有一张图片，且没有动态效果
  playImage() {
    if (!this.image) return;
    this.image.show();
    this.imgTimer = setTimeout(() => {
      const resetTime = this.imgEndTime - new Date().getTime(); // 离这段播放结束还差的毫秒值
      if (resetTime > 0) {
        this.playImage();
        this.currentTime = this.activeSegment.endTime - resetTime / 1000;
      } else {
        this.playerEndCallback();
      }
      this.timeupdateCallback();
    }, 20);
  }
  showImage() {
    if (!this.image) return;
    this.image.show();
  }
  pauseImage() {
    clearTimeout(this.imgTimer);
  }
  hideImage() {
    this.image?.hide();
  }
  /****************************** 图片 ******************************/

}

export class AudioPlayer {
  audio: HTMLAudioElement;
  _on: any;
  oncePlay: boolean;

  constructor({ audioUrl, on = {} }) {
    this.audio = new Audio();
    const src = stringifyUrl({
      url: audioUrl,
      query: {
        _t: Date.now() // 避免音频走本地缓存，缓存偶现播放不出来
      }
    });
    this._on = on || {}
    this.loadAudio(src);
  }

  async loadAudio(src) {
    let url = src;
    try {
      if(isIOS) {
        const response = await fetch(src);
        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }
        // const blob = await response.blob();
        // url = URL.createObjectURL(blob);
      }
    } catch (error) {
      url = src;
      console.error('Error loading audio:', error);
    }
    this.audio.src = url;
    this.audio.loop = false;
    this.audio.preload = 'metadata'
    this.addEvents()
  }
  get currentTime() {
    return this.audio.currentTime
  }
  get duration() {
    return this.audio.duration
  }
  get paused() {
    return this.audio.paused
  }
  checkPlay() {
    return new Promise((resolve, reject) => {
      if (this.oncePlay || !this.paused) {
        // 曾经播放或者正在播放，检查通过
        resolve(true);
      } else {
        // 没有播放过，进行短暂的静音播放，避免没有在用户点击时播放报错
        this.audio.muted = true;
        this.audio.play().then(() => {
          this.oncePlay = true;
          this.pause();
          this.audio.muted = false;
          resolve(true);
        });
      }
    })
  }
  play(time = 0) {
    // this.audio 从 第time秒进行播放
    this.audio.currentTime = time;
    this.audio.play().then(() => {
      this.oncePlay = true;
    }).catch((err) => {
      this.oncePlay = false;
      console.log(err, err?.message, 'audio play error')
      this._on?.error && this._on.error(err);
    });
  }
  pause() {
    this.audio.pause()
  }
  updateAudioUrl(audioUrl) {
    this.audio.src = audioUrl
  }
  addEvents() {
    Object.keys(this._on).forEach(key => {
      this.audio.addEventListener(key, this._on[key])
    })
  }
  removeEvents() {
    Object.keys(this._on).forEach(key => {
      this.audio.removeEventListener(key, this._on[key])
    })
  }
  destroy() {
    this.removeEvents()
  }
}
class videoPlayer {
  video: HTMLVideoElement;
  _on: any;
  oncePlay: boolean;
  muted: boolean;
  speed: number;
  initCallback: any;

  constructor({ videoUrl, muted = false, speed = 1, on = {} }) {
    this.video = document.createElement('video');
    const src = stringifyUrl({
      url: videoUrl,
      query: {
        _t: Date.now() // 避免视频走本地缓存，缓存偶现播放不出来
      }
    });
    // this.video.src = videoUrl;
    this.speed = speed;
    this.muted = muted;
    this._on = on || {}
    this.loadVideo(src);
  }
  setVideoAttr() {
    this.video.muted = this.muted;
    this.video.loop = false;
    this.video.preload = 'metadata'
    this.video.controls = false;
    this.video.playbackRate = this.speed;
    // @ts-ignore
    this.video.playsInline = true;
    this.video.setAttribute('webkit-playsinline', 'true');

    this.oncePlay = false; // 是否曾经播放

    this.video.crossOrigin = 'anonymous'; // 允许跨域，以便canvas转图片
  }
  async loadVideo(src) {
    let url = src;
    try {
      if(isIOS) {
        const response = await fetch(src);
        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }
        // const blob = await response.blob();
        // url = URL.createObjectURL(blob);
      }
    } catch (error) {
      url = src;
      console.error('Error loading video:', error);
    }
    this.video.src = url;
    this.setVideoAttr();
    this.addEvents()
  }

  get currentTime() {
    return this.video.currentTime
  }
  get duration() {
    return this.video.duration
  }
  get paused() {
    return this.video.paused
  }
  setSize(videoWidth, videoHeight) {
    this.video.width = videoWidth;
    this.video.height = videoHeight;
  }
  setCurrentTime(time) {
    this.video.currentTime = time;
  }
  checkPlay() {
    return new Promise((resolve, reject) => {
      if (this.oncePlay || !this.paused) {
        // 曾经播放或者正在播放，检查通过
        resolve(true);
      } else {
        // 没有播放过，进行短暂的静音播放，避免没有在用户点击时播放报错
        this.video.muted = true;
        this.video.play().then(() => {
          this.pause();
          this.video.muted = this.muted;
          // console.log('checkPlay pause')
          resolve(true);
        });
      }
    })
  }
  play(time = 0) {
    this.video.currentTime = time * this.speed;
    return this.video.play().then(() => {
      // console.log('video play success')
      this.oncePlay = true;
      return true;
    }).catch((err) => {
      this.oncePlay = false;
      // 会报错 play can only be initiated by a user gesture.，所以提供checkPlay方法，在用户点击后play一次
      console.log(err, err?.message, 'video play error')
      // 增加错误回调的触发，即播放失败时将外层的播放按钮变为暂停
      this._on?.error && this._on.error(err);
    });
  }
  pause() {
    if (this.video.paused) return;
    this.video.pause()
    // this.video.load(); // 暂时不加，否则偶现暂停后视频跳转到第一幕
  }
  updateVideoUrl(videoUrl) {
    this.video.src = videoUrl
  }

  addEvents() {
    Object.keys(this._on).forEach(key => {
      this.video.addEventListener(key, this._on[key])
    })
  }
  removeEvents() {
    Object.keys(this._on).forEach(key => {
      this.video.removeEventListener(key, this._on[key])
    })
  }
  destroy() {
    this.removeEvents()
  }
}

/**
 * 字幕Layer
 */
export class SubtitlesLayer {
  segments: any[] = [];
  currentTime = 0; // 记录当前显示时间
  stage: Konva.Stage; // 画布
  scaleRatio: number = 1; // 缩放比例
  layerText: Konva.Layer;   // 装饰层-字幕
  textNodes: Konva.Text[][] = []; // 文本节点
  avtivedText: Konva.Text;
  tr: Konva.Transformer;
  trPadding = 2;
  trMargin = 2;
  _on: any = {};

  constructor({ segments, stage, scaleRatio = 1, on = {} }) {
    this.segments = segments;
    this.scaleRatio = scaleRatio;
    this.stage = stage;
    this.layerText = new Konva.Layer();
    this.stage.add(this.layerText);
    this.initTextNodes();
    this.bindEvent();
    this._on = on;
  }

  // 重设尺寸
  resize(scaleRatio = 1) {
    this.scaleRatio = scaleRatio;
    this.initTextNodes();
    this.show(this.currentTime);
  }
  // 更新字幕
  updateSubtitle(segments) {
    this.segments = segments;
    this.initTextNodes();
    this.show(this.currentTime);
  }

  // 初始化文本节点
  initTextNodes() {
    for (let index = 0; index < this.segments.length; index++) {
      const segment = this.segments[index];
      const { textList = [] } = segment;
      this.textNodes[index] = [];
      textList.forEach(item => {
        const textParams = this.getTextParams(item);
        const TextNode = new Konva.Text(textParams);
        if (textParams.align === 'center') {
          TextNode.offsetX(TextNode.width() / 2);
        }
        // Text.setAttr('globalCompositeOperation', 'source-atop');
        this.textNodes[index].push(TextNode);
      })
    }
    // console.log('initTextNodes', this.textNodes);
  }
  show(time) {
    this.currentTime = time;
    const index = this.getSegmentIndexByTime(time);
    if (index === -1) return;
    this.layerText.removeChildren(); // 清空子元素
    const { textList = [] } = this.segments[index];
    textList.forEach((item, i) => {
      if (item.startTime <= time && item.endTime > time) {
        const Text = this.textNodes[index][i];
        this.layerText.add(Text);
        this.layerText.draw();
      }
    })
  }
  getTextParams(item) {
    const { srtParam = {}, text, uuid } = item;
    const { fontPosX, fontPosY, fontSize, fontColour, fontFamily } = srtParam;
    // const diffWidth = this.trPadding + this.trMargin;
    const stageHeight = this.stage.height();
    const stageWidth = this.stage.width();
    const textParams = {
      uuid,
      text,
      fill: fontColour,
      stroke: '#000',
      strokeWidth: 1,
      fillAfterStrokeEnabled: true,
      x: Math.floor(fontPosX * this.scaleRatio),
      y: Math.floor(fontPosY * this.scaleRatio),
      // width: stageWidth - diffWidth * 2,  // 减去20，用于tr的padding
      fontSize: Math.floor(fontSize * this.scaleRatio),
      fontFamily: fontNameEn(fontFamily),
      align: 'left', // 默认左对齐
      wrap: 'none', //文字不换行
      name: 'text',
      // draggable: true,  // 可拖拽
      dragBoundFunc: function (pos) {
        let { x, y } = pos;
        // y方向不超出边界
        if (y < 0) {
          y = 0;
        } else if (y > stageHeight - this.height()) {
          y = stageHeight - this.height();
        }
        // x方向不超出边界
        if (fontPosX === 'center') { //限制垂直方向移动，x不变
          x = this.absolutePosition().x
        } else if (x < 0) {
          x = 0;
        } else if (x > stageWidth - this.width()) {
          x = stageWidth - this.width();
        }
        return { x, y };
      }
    }

    if (fontPosX === 'center') {
      // textParams.x = diffWidth;
      textParams.x = stageWidth / 2;
      textParams.align = 'center'; // 居中对齐
    }

    return textParams;
  }

  // 根据时间获取要渲染的segment
  getSegmentIndexByTime(time) {
    return this.segments.findIndex(item => item.startTime <= time && item.endTime > time)
  }

  bindEvent() {
    const stage = this.stage;
    const layer = this.layerText;
    stage.on('click tap', (e) => {
      this.tr?.destroy();
      this.avtivedText?.setAttr('draggable', false);
      if (e.target === stage || !e.target.hasName('text') || !(e.target instanceof Konva.Text)) {
        return;
      }
      // Transformer可以用来调整节点尺寸和旋转节点，此处只用于标记和设置可拖拽
      const tr = new Konva.Transformer(this.getTrConfig());
      this.tr = tr;
      layer.add(tr);
      tr.nodes([e.target]);
      this.avtivedText = e.target;
      // this.avtivedText.setAttr('draggable', true); // 先不给拖拽
      layer.draw();
      if (this._on.edit) {
        this._on.edit(e.target.attrs.uuid);
      }
    });
    stage.on('dragend', (e) => {
      if (e.target !== this.avtivedText) return;
      const { x, y, align, uuid } = e.target.attrs;
      const config = { x: parseInt(x), y: parseInt(y), uuid };
      if (align === 'center') delete config.x;
      if (this._on.change) {
        this._on.change(config);
      }
    });
  }

  getTrConfig(color = '#E7166B'): Konva.TransformerConfig {
    const trConfig: Konva.TransformerConfig = {
      enabledAnchors: [],
      anchorStroke: color,
      anchorFill: color,
      anchorSize: 0,
      borderStroke: color,
      rotateAnchorOffset: 0,
      padding: this.trPadding,
    };
    return trConfig;
  }
}